import React from 'react';
import { Icons } from '../../Icons';
export const chevronIcon = (React.createElement(Icons, { iconName: "ic-ui-chevron-down-sm", className: "ic-ui-chevron-down-sm" }));
//# sourceMappingURL=icons.js.map